/* PhysicalAssessmentMixin.ts */

import { Component, Mixins } from 'vue-property-decorator';
import { SportModel } from '@/models/sport';
import { StringsMixin } from './StringsMixin';

interface PhysicalAssessmentInformation {
	name: string,
	abbr: string,
	description: string,
	measurement: string
}

@Component
export class PhysicalAssessmentMixin extends Mixins(StringsMixin) {
	PhysicalTestsInfo(sport: SportModel = undefined): Array<PhysicalAssessmentInformation> {
		if( this.IsEmpty(sport) ) return [];

		const physicalTestsInfo: Array<PhysicalAssessmentInformation> = sport.physicalAssessmentLabels.map(l => {
			return {name: l.label, abbr: l.abbreviation, description: l.description, measurement: l.measurement}
		});
		return physicalTestsInfo;
	}

	PhysicalTestsInfoItems: Array<PhysicalAssessmentInformation> = [
		{
			name: "Acceleration",
			abbr: "Accl",
			description: "Sprint time over the first 10m",
			measurement: "Running time from 0m to 10m"
		},
		{
			name: "Speed",
			abbr: "Spd",
			description: "Maximal running speed during a sprint",
			measurement: "Running time from 20m and 35m"
		},
		{
			name: "Agility",
			abbr: "Agl",
			description: "Reactive strength index using a Drop Jump",
			measurement: "Drop Jump Test. Jump height and ground contact time"
		},
		{
			name: "Power",
			abbr: "Pow",
			description: "Leg muscle power using Counter Movement Jump",
			measurement: "Counter Movement Jump. Jump height"
		},
		{
			name: "Recovery",
			abbr: "Rec",
			description: "Distance covered during a YoYo Test",
			measurement: "YoYo Test"
		},
		{
			name: "10m",
			abbr: "10m",
			description: "Sprint time over the first 10m",
			measurement: "Running time from 0m to 10m"
		},
		{
			name: "40m",
			abbr: "40m",
			description: "Sprint time over 40m",
			measurement: "Running time from 0m to 40m"
		},
		{
			name: "Long Jump",
			abbr: "Jmp",
			description: "Jump distance",
			measurement: "Jump"
		},
		{
			name: "Bronco",
			abbr: "Bco",
			description: "Time for five 60m, 40m and 20m shuttle runs",
			measurement: "Running time for 5 shuttles"
		}
	]

}
